import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { createBookmark, createFolder, updateBookmark } from "../database";

const ItemForm = ({
  data,
  closeShowItemForm,
  clearSelectedItem,
  folders,
}: any) => {
  const { authUser } = useAuth();
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [description, setDescription] = useState("");
  const [folderId, setFolderId] = useState("");
  const [newFolderName, setNewFolderName] = useState("");
  const [saveStatus, setSaveStatus] = useState("Save");

  useEffect(() => {
    if (data) {
      setTitle(data.title || "");
      setUrl(data.url);
      setDescription(data.description || "");
      setFolderId(data.folderId || "");
    }
  }, [data]);

  // useEffect(() => {
  //   // chrome current url link
  //   // In your React component
  //   chrome.runtime.sendMessage({ type: "GET_CURRENT_URL" }, (response) => {
  //     if (response && response.url) {
  //       const currentUrl = response.url;
  //       console.log("Current URL:", currentUrl);
  //       // Do something with the current URL
  //     }
  //   });
  // }, []);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!authUser) return;

    const formInput = { title, url, description };

    setSaveStatus("Saving");
    let selectedFolderId = folderId || "";
    try {
      if (data) {
        if (folderId === "cmg-new-folder-10") {
          if (!newFolderName) return;
          const newFolder: any = await createFolder({
            name: newFolderName,
            createdBy: authUser.email,
            _createdAt: new Date(),
          });
          selectedFolderId = newFolder;
        }
        await updateBookmark(
          data.id,
          { ...formInput, folderId: selectedFolderId, _updatedAt: new Date() },
          authUser.email
        );
        clearSelectedItem();
      } else {
        if (folderId === "cmg-new-folder-10") {
          if (!newFolderName) return;
          const newFolder: any = await createFolder({
            name: newFolderName,
            createdBy: authUser.email,
            _createdAt: new Date(),
          });
          selectedFolderId = newFolder;
        }
        await createBookmark({
          ...formInput,
          folderId: selectedFolderId,
          createdBy: authUser.email,
          _createdAt: new Date(),
        });
      }
    } catch {
      window.alert("Something went wrong. Please try again.");
    } finally {
      setTitle("");
      setUrl("");
      setDescription("");
      setFolderId("");
      closeShowItemForm();
      setSaveStatus("Save");
    }
  };

  return (
    <form className='form' onSubmit={handleSubmit}>
      <div>
        <input
          type='text'
          placeholder='Title'
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div>
        <input
          type='url'
          placeholder='URL *'
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          required
        />
      </div>
      <div>
        <textarea
          placeholder='Description'
          rows={10}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      {/* folder select */}
      <div>
        <select
          value={folderId}
          onChange={(e) => setFolderId(e.target.value)}
          // required
        >
          <option value=''>
            {folders?.length ? "Select a folder" : "No folders available"}
          </option>
          {folders
            ?.filter((f: any) => f.createdBy === authUser.email)
            ?.map((folder: any) => (
              <option key={folder.id} value={folder.id}>
                {folder.name}
              </option>
            ))}
          {folders?.filter((f: any) => f.createdBy !== authUser.email)?.length >
            0 && <option disabled>Shared folders</option>}
          {folders
            ?.filter((f: any) => f.createdBy !== authUser.email)
            ?.map((folder: any) => (
              <option key={folder.id} value={folder.id} title={folder?.createdBy}>
                {folder.name} ({folder.createdBy})
              </option>
            ))}
          <option value='cmg-new-folder-10' style={{ color: "Highlight" }}>
            + Add new folder
          </option>
        </select>
      </div>
      {folderId === "cmg-new-folder-10" && (
        <div>
          <input
            type='text'
            placeholder='New folder name'
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
          />
        </div>
      )}
      <div className='form-ctas'>
        <button type='button' onClick={closeShowItemForm}>
          Cancel
        </button>
        <button type='submit' disabled={saveStatus === "Saving"}>
          {saveStatus}
        </button>
      </div>
    </form>
  );
};

export default ItemForm;
